import { Link } from 'react-router-dom';
import Header from '@components/Header';
import Footer from '@components/Footer';

function ForgotPassword() {
    const handleContactSupport = () => {
        window.open('https://t.me/DinoBytes', '_blank');
    };

    return (
        <div className="auth-page">
            <Header />
            <main className="auth-container" style={{ maxWidth: '500px', margin: '120px auto', padding: '2rem' }}>
                {/* Icon */}
                <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                    <div style={{ 
                        width: '80px', 
                        height: '80px', 
                        margin: '0 auto 1rem', 
                        background: 'linear-gradient(135deg, #d4af37, #f4d03f)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '2.5rem'
                    }}>
                        🔒
                    </div>
                    <h2 style={{ margin: '0 0 0.5rem 0', fontSize: '1.75rem' }}>Lupa Password?</h2>
                    <p style={{ color: '#999', margin: 0 }}>Kami siap membantu Anda</p>
                </div>

                {/* Info Box */}
                <div style={{ 
                    background: 'rgba(212, 175, 55, 0.1)', 
                    border: '1px solid #d4af37', 
                    borderRadius: '12px', 
                    padding: '1.5rem',
                    marginBottom: '1.5rem'
                }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '1rem' }}>
                        <i className="fas fa-info-circle" style={{ color: '#d4af37', fontSize: '1.5rem', marginTop: '0.25rem' }}></i>
                        <div>
                            <h3 style={{ margin: '0 0 0.5rem 0', color: '#d4af37', fontSize: '1.1rem' }}>
                                Reset Password via Support
                            </h3>
                            <p style={{ color: '#ccc', margin: '0', lineHeight: '1.6' }}>
                                Untuk keamanan akun Anda, reset password hanya dapat dilakukan melalui layanan pelanggan kami.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Steps */}
                <div style={{ marginBottom: '2rem' }}>
                    <h4 style={{ color: '#fff', marginBottom: '1rem', fontSize: '1rem' }}>
                        <i className="fas fa-list-ol" style={{ marginRight: '0.5rem', color: '#d4af37' }}></i>
                        Cara Reset Password:
                    </h4>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                            <div style={{ 
                                minWidth: '32px', 
                                height: '32px', 
                                background: 'rgba(212, 175, 55, 0.2)',
                                border: '2px solid #d4af37',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 'bold',
                                color: '#d4af37'
                            }}>
                                1
                            </div>
                            <p style={{ color: '#ccc', margin: 0, lineHeight: '1.6' }}>
                                Hubungi support kami via Telegram
                            </p>
                        </div>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                            <div style={{ 
                                minWidth: '32px', 
                                height: '32px', 
                                background: 'rgba(212, 175, 55, 0.2)',
                                border: '2px solid #d4af37',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 'bold',
                                color: '#d4af37'
                            }}>
                                2
                            </div>
                            <p style={{ color: '#ccc', margin: 0, lineHeight: '1.6' }}>
                                Berikan informasi akun Anda (email/username)
                            </p>
                        </div>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                            <div style={{ 
                                minWidth: '32px', 
                                height: '32px', 
                                background: 'rgba(212, 175, 55, 0.2)',
                                border: '2px solid #d4af37',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 'bold',
                                color: '#d4af37'
                            }}>
                                3
                            </div>
                            <p style={{ color: '#ccc', margin: 0, lineHeight: '1.6' }}>
                                Tim kami akan membantu proses reset password Anda
                            </p>
                        </div>
                    </div>
                </div>

                {/* Contact Support Button */}
                <button
                    onClick={handleContactSupport}
                    className="auth-btn primary"
                    style={{ 
                        width: '100%', 
                        padding: '1rem',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.75rem',
                        background: 'linear-gradient(135deg, #0088cc, #0077b3)',
                        marginBottom: '1rem'
                    }}
                >
                    <i className="fab fa-telegram-plane" style={{ fontSize: '1.25rem' }}></i>
                    Hubungi Support via Telegram
                </button>

                {/* Additional Info */}
                <div style={{ 
                    background: 'rgba(0,0,0,0.3)', 
                    borderRadius: '8px', 
                    padding: '1rem',
                    marginBottom: '1.5rem'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                        <i className="fas fa-clock" style={{ color: '#d4af37' }}></i>
                        <span style={{ color: '#d4af37', fontWeight: 'bold', fontSize: '0.9rem' }}>
                            Waktu Respon
                        </span>
                    </div>
                    <p style={{ color: '#999', margin: 0, fontSize: '0.9rem', lineHeight: '1.5' }}>
                        Support kami biasanya merespon dalam 1-24 jam (tergantung antrian).
                    </p>
                </div>

                {/* Back to Login */}
                <div style={{ textAlign: 'center', color: '#999' }}>
                    <p style={{ marginBottom: '0.5rem' }}>Ingat password Anda?</p>
                    <Link to="/login" style={{ color: '#d4af37', textDecoration: 'none', fontWeight: 'bold' }}>
                        <i className="fas fa-arrow-left" style={{ marginRight: '0.5rem' }}></i>
                        Kembali ke Login
                    </Link>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default ForgotPassword;
